module.exports = __webpack_public_path__ + "img/trip_sendai15.66b0c10f.jpg";